import { Module } from "vuex";
import { StoreState } from "@/store/type";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { ICorporatePolicyState } from "../types";

const corporatePolicyModule: Module<ICorporatePolicyState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default corporatePolicyModule;
